import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AutocompleteDataLoader } from 'src/app/components/autocomplete/autocomplete-data-loader';
import { AutocompleteOption } from 'src/app/components/autocomplete/autocomplete-option';
import { ReturnMessage } from 'src/app/models/return-message';
import { QuoteService } from '../quote/quote.service';

@Injectable() // Not a singleton
export class QuoteQuestionDropDownAutocompleteDataLoaderService implements AutocompleteDataLoader {

  dropDownId: number;

  set dropDownIdSetter(id: number) { this.dropDownId = id; }
  get dropDownIdGetter() { return this.dropDownId; }

  constructor(private quoteService: QuoteService) { }

  load(searchTerm: string): Observable<ReturnMessage<AutocompleteOption[]>> {
    if (!this.dropDownId)
      throw Error("Drop down Id not set.");

    let params = { 
      searchAll: false,
      search: searchTerm,
      optionalData: {
        dropDownId: this.dropDownId
      }
    };
    return this.quoteService.getQuoteQuestionDropDownOptions(params)
      .pipe(
        map(response => {
          return this.transformResponse(response);
        })
      );
  }

  loadAll(): Observable<ReturnMessage<AutocompleteOption[]>> {
    if (!this.dropDownId)
      throw Error("Drop down Id not set.");

      let params = { 
        searchAll: true,
        search: null, 
        optionalData: {
          dropDownId: this.dropDownId
        }
      };
      return this.quoteService.getQuoteQuestionDropDownOptions(params)
        .pipe(
          map(response => {
            return this.transformResponse(response);
          })
        );
  }

  transformResponse(response: ReturnMessage<{ value:string; label:string }[]>) {

    let newReturnMessage = <ReturnMessage<AutocompleteOption[]>>{
      success: response.success,
      message: response.message,
      title: response.title,
      options: response.options,
      returncode: response.returncode
    };

    if (response.success) {
      newReturnMessage.payload = <AutocompleteOption[]>[];
      for (const obj of response.payload) {
        newReturnMessage.payload.push({ 
          id: obj.value, 
          description: obj.label, 
          sourceObject: obj 
        });
      }
    }

    return newReturnMessage;
  }
}
